<template>
  <UiLoading v-if="newUiEnabled" :label="uiLabel" :inline="compact" />

  <slot v-else>
    <b-spinner v-bind="$attrs" />
  </slot>
</template>

<script setup lang="ts">
import { useNewUiEnabled } from "@/components/newUi/core/useNewUiEnabled";

defineOptions({ inheritAttrs: false });

withDefaults(
  defineProps<{
    uiLabel?: string;
    compact?: boolean;
  }>(),
  {
    uiLabel: undefined,
    compact: false,
  },
);

const newUiEnabled = useNewUiEnabled();
</script>
